import CommonObject from '../../models/common/commonObject'
import {
  addImageHistoryItem,
  setAttribute,
} from '../../stores/editor/editor.reducer'
import {IMG_ATTRIBUTES_UPDATED} from '../../models/editor/imgHistoryItemAction'
import {AppDispatch} from '../../stores/configureStore'
import {Img} from '../../models/editor/img'

export const getOrigValuesByAttributes = (
  object: CommonObject,
  attributes: string[],
): CommonObject => {
  let result: {[key: string]: any} = {}

  Object.keys(object)
    .filter((key: string) => attributes.includes(key))
    .forEach((key: string) => (result = {...result, [key]: object[key]}))

  return result
}

export const handleUpdatedAttributes = (
  dispatch: AppDispatch,
  img: Img,
  attributes: {[key: string]: any},
) => {
  const origAttributes = getOrigValuesByAttributes(img, Object.keys(attributes))

  dispatch(
    addImageHistoryItem({
      item: {
        img,
        origAttributes,
        newAttributes: attributes,
        action: IMG_ATTRIBUTES_UPDATED,
      },
    }),
  )

  dispatch(
    setAttribute({
      id: img.id,
      data: attributes,
    }),
  )
}
